import {
  Component,
  Input,
  ViewChild,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { MatDialog, MatSnackBar, MatPaginator } from '@angular/material';
import { TournamentDetailCreateTeamComponent } from '../tournament-detail-create-team/tournament-detail-create-team.component';
import {
  TournamentTeam,
  SignInTeamRequest,
  Team,
  Inscription,
} from '@app/_models/tournament.model';
import { TournamentsService } from '@app/services/tournaments/tournaments.service';
import { TournamentTeamsDataSource } from '@app/services/tournaments/tournamentsTeams.datasource';
import { tap } from 'rxjs/operators';
import { Dictionary } from '@app/_models/shared.model';

@Component({
  selector: 'tournament-detail-teams',
  templateUrl: './tournament-detail-teams.component.html',
  styleUrls: ['./tournament-detail-teams.component.scss'],
})
export class TournamentDetailTeamsComponent implements OnInit, AfterViewInit {
  constructor(
    private _dialog: MatDialog,
    private _tournamentService: TournamentsService,
    private _snackBar: MatSnackBar
  ) { }
  displayedColumns = [
    'name',
    'administrator',
    'phone',
    'teamQuantity',
    'paymentStatus',
  ];
  totalRecords = 0;
  @Input() tournamentId: number;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  tournamentTeamsList = new TournamentTeamsDataSource(this._tournamentService);
  paymentStates: Dictionary[];

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this._tournamentService.getTeamsPaymentStates().subscribe(states => {
      this.paymentStates = states;
    });
  }

  confirmTeamForTournament(inscription: Inscription) {
    this._tournamentService.confirmTeamForTournament(this.tournamentId, inscription.id).subscribe(() => {
      this.loadTournamentTeams();
    });
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.paginator.page.pipe(tap(() => this.loadTournamentTeams())).subscribe();
    this.loadTournamentTeams();
  }

  loadTournamentTeams() {
    this.tournamentTeamsList.loadTournamentTeams(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.tournamentId
    );
  }

  getPaymentStatus(statusId) {
    const status = this.paymentStates.find(e => statusId === e.value);
    return status.name;
  }

  openNewTeamDialog() {
    const dialog = this._dialog.open(TournamentDetailCreateTeamComponent, {
      width: '550px',
    });

    const signInEvent = dialog.componentInstance.addTeamEvent.subscribe(
      (team: Team) => {
        const signInRequest: SignInTeamRequest = {
          team: team.id,
          status: 1,
        };
        this._tournamentService.signInTeam(this.tournamentId, signInRequest).subscribe(() => {
          this._snackBar.open('Equipo agregado correctamente', '', {
            duration: 3000,
          });
          dialog.close();
          this.loadTournamentTeams();
        });
      }
    );

    const closedDialog = dialog.componentInstance.closeEvent.subscribe(() => {
      dialog.close();
    });

    dialog.afterClosed().subscribe(() => {
      closedDialog.unsubscribe();
      signInEvent.unsubscribe();
    });
  }
}
